import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _type_of from "@swc/helpers/src/_type_of.mjs";
import { getRoutes, RegexType, PLACEHOLDER_VAR } from "./routes";
/**
 * Transform strings like 'loueur-jucy-rentals' to "Loueur Jucy Rentals"
 */ var upperCaseWord = function(str) {
    var arr = str.replace(/-/g, " ").split(" ");
    var i;
    for(i = 0; i < arr.length; i += 1){
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join(" ");
};
var getTrackingDataForPath = function(settings, path) {
    // remove query string params
    var ref = _sliced_to_array(path.split("?"), 1), pathname = ref[0];
    var routes = getRoutes(settings);
    var route = routes.find(function(r) {
        return r.path === pathname || _type_of(r.path) === (typeof RegexType === "undefined" ? "undefined" : _type_of(RegexType)) && new RegExp(r.path).test(pathname);
    });
    if (!route) {
        return null;
    }
    var pathIsRegex = _type_of(route.path) === (typeof RegexType === "undefined" ? "undefined" : _type_of(RegexType));
    if (pathIsRegex) {
        var regex = new RegExp(route.path);
        var ref1 = _sliced_to_array(pathname.match(regex) || [], 3), fullMatch = ref1[1], match = ref1[2];
        if (match) {
            route.tracking.virtPath = route.tracking.virtPath.replace(PLACEHOLDER_VAR, match);
            // TODO: assign Country or State to `landingpageKategorie`
            route.tracking.landingpageKategorie = upperCaseWord(fullMatch);
            route.tracking.englishPageName = route.tracking.englishPageName.replace(PLACEHOLDER_VAR, match);
        }
    }
    return route.tracking;
};
export { getTrackingDataForPath };
